import { useCallback, useEffect, useState } from "react";
import { adminFetch, fmtDateTime } from "./adminApi";

export function RetentionBanner({ adminKey, onPurged, onError }) {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await adminFetch("/admin/retention", adminKey);
      setInfo(await res.json());
    } catch (e) { /* bandeau silencieux si indisponible */ }
  }, [adminKey]);

  useEffect(() => { load(); }, [load]);

  async function purgeNow() {
    if (!window.confirm(`Supprimer maintenant tous les audits de plus de ${info.retention_days} jours ?`)) return;
    setBusy(true);
    try {
      const res = await adminFetch("/admin/purge", adminKey, { method: "POST" });
      const data = await res.json();
      await load();
      onPurged(data.deleted);
    } catch (e) {
      onError(e.message);
    } finally {
      setBusy(false);
    }
  }

  if (!info) return null;
  if (!info.enabled) {
    return (
      <div className="admin-banner admin-banner-muted" data-testid="admin-retention-banner">
        Purge RGPD automatique <strong>désactivée</strong> (<code>AUDIT_RETENTION_DAYS=0</code>).
      </div>
    );
  }
  const months = Math.round(info.retention_days / 30);
  const soon = info.expiring_within_30_days;
  return (
    <div className={`admin-banner${soon > 0 ? " admin-banner-warn" : ""}`} data-testid="admin-retention-banner">
      <div className="admin-banner-body">
        <strong>Purge RGPD automatique</strong> — les audits de plus de <strong>{months} mois</strong> ({info.retention_days} jours)
        sont supprimés chaque jour.
        {soon > 0
          ? <> <span className="admin-banner-count" data-testid="admin-retention-expiring">{soon}</span> audit{soon > 1 ? "s" : ""} sera{soon > 1 ? "ont" : ""} purgé{soon > 1 ? "s" : ""} dans les 30 prochains jours.</>
          : <> Aucun audit n'arrive à échéance dans les 30 prochains jours.</>}
        <span className="admin-muted"> · Dernière purge : {info.last_purge_at ? `${fmtDateTime(info.last_purge_at)} (${info.last_purge_count} supprimé${info.last_purge_count > 1 ? "s" : ""})` : "—"}</span>
      </div>
      <button className="audit-btn audit-btn-ghost admin-btn-sm" onClick={purgeNow} disabled={busy} data-testid="admin-purge-now">
        {busy ? "Purge…" : "Purger maintenant"}
      </button>
    </div>
  );
}
